export const KB_ENDPOINTS = {
    GET_ALL: '/api/knowledge-bases',
    CREATE: '/api/knowledge-bases',
    GET_BY_ID: (id: string) => `/api/knowledge-bases/${id}`,
    UPDATE: (id: string) => `/api/knowledge-bases/${id}`,
    DELETE: (id: string) => `/api/knowledge-bases/${id}`,
} as const;
